import React, { useState } from "react";
import CommonAccountPanelView from "presentational/account/CommonAccountPanelView";
import LoadingModalView from "presentational/common/modals/LoadingModalView";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import { checkEmailExist } from "lib/accountDuplicationChecker";
import { isValidInput } from "lib/textFilter";
import Service from "lib/service-amp";
import PropTypes from "prop-types";

ForgotPwRequestPanel.propTypes = {
  onLogInBtnClick: PropTypes.func.isRequired,
  onRequestBtnClick: PropTypes.func.isRequired,
  goToSocialPage: PropTypes.func.isRequired
};

function ForgotPwRequestPanel(props) {
  const {
    onLogInBtnClick,
    onRequestBtnClick,
    goToSocialPage,
    AppErrorActions,
    NoticeModalActions
  } = props;
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const displayNotice = (type, callback) => {
    let content;
    switch (type) {
      case "emailNotFilledOut":
        content = <TXT name="msg_enterEmail" />;
        break;
      case "wrongEmail":
        content = <TXT name="msg_enterValidEmail" />;
        break;
      case "invalidUser":
      case "userNotFound":
        content = <TXT name="msg_emailNotRegistered" />;
        break;
      case "googleAuthUser":
        content = <TXT name="msg_registeredUserInGoogle" />;
        break;
      case "limitExceed":
        content = <TXT name="msg_passwordResetRequestExceeded" />;
        break;
      case "defaultError":
      default:
        content = <TXT name="msg_commonNetworkError" />;
        break;
    }
    NoticeModalActions.openModal({ content, callback });
  };

  const handleTextChange = (type, value) => {
    if (type === "email") setEmail(value);
  };

  const handleSubmitBtnClick = async () => {
    if (!email) {
      displayNotice("emailNotFilledOut");
      return null;
    }

    if (!isValidInput("email", email)) {
      displayNotice("wrongEmail");
      return null;
    }

    if (isLoading) return null;

    await setIsLoading(true);

    const { emailExist, isGoogleAuthUser } = await checkEmailExist(
      email.trim()
    );
    if (!emailExist) {
      displayNotice("invalidUser");
      setIsLoading(false);
      return null;
    }
    if (isGoogleAuthUser) {
      displayNotice("googleAuthUser", () => {
        goToSocialPage();
      });
      setIsLoading(false);
      return null;
    }

    const { code, res } = await Service.forgotPassword(email.trim());
    switch (code) {
      case "ok":
        onRequestBtnClick(email);
        break;
      case "InvalidParameterException":
        /**
         * 이런 메시지 받는다.
         * message: "Cannot reset password for the user as there is no registered/verified email or phone_number"
         * 이메일 인증되어 정식으로 생성된 계정아닌, superuser가 이메일 인증없이 강제로 만든 계정에서 비밀번호 수정시 상단의 에러 발생하더라.
         */
        displayNotice("wrongEmail");
        setIsLoading(false);
        AppErrorActions.setSafeAppError(Error(res));
        break;
      case "UserNotFoundException":
        displayNotice("userNotFound");
        setIsLoading(false);
        break;
      case "LimitExceededException":
        displayNotice("limitExceed");
        setIsLoading(false);
        break;
      case "error":
      default:
        displayNotice("defaultError");
        setIsLoading(false);
        AppErrorActions.setSafeAppError(Error(res));
        break;
    }
  };

  return (
    <div>
      <CommonAccountPanelView
        title={<TXT name="titlePanel_resetPassword" />}
        textElement={["email"]}
        onInputValueChange={handleTextChange}
        firstBtnText={<TXT name="btnPanel_submitResetPassword" />}
        onFirstBtnClick={handleSubmitBtnClick}
        modeToggleBtnText={<TXT name="btnPanelToggle_goLogIn" />}
        onModeToggleBtnClick={onLogInBtnClick}
      />
      <LoadingModalView open={isLoading} />
    </div>
  );
}

export default withStore({
  dispatchMap: ["appError", "noticeModal"]
})(ForgotPwRequestPanel);
